<div class="flex flex-col gap-3 h-full pb-0">
    <div class="flex flex-col gap-1">
        <div class="flex justify-between items-center">
            <div class="w-[50%] flex items-center gap-2 text-sm">
                @if(canCreateDocuments()){
                <app-menu #optionsMenu [items]="optionsMenuItems" (itemSelected)="onOptionSelect($event)"
                    step-id="project-dashboard-step1" (visibleChange)="isOptionsMenuOpen = $event"
                    [pTooltip]="'Options'" tooltipPosition="top">
                    <app-button label="{{'Add documents' | textCase}}" variant="filled" severity="primary"
                        (clicked)="openOptionsPanel($event)" icon="pi pi-plus" [disabled]="!projectActive" />
                </app-menu>
                }
                <app-search-bar placeholder="{{'Search document' | textCase}}" [(ngModel)]="searchValue"
                    (searchChange)="onSearch()" class="w-full"></app-search-bar>
            </div>
            <div class="flex items-center gap-2 text-sm">
                <!-- View Toggle -->
                <app-select-button [options]="viewModeOptions" [(ngModel)]="viewMode"
                    (selectionChange)="onViewModeChange($event)" [disabled]="!projectActive" size="small">
                </app-select-button>

                <!-- Sort -->
                <app-sort-popover [fields]="sortFields" [(sortField)]="sortField" [(sortOrder)]="sortOrder"
                    [disabled]="!projectActive" (sortChange)="sortDocuments()" />


                <!-- Filter -->
                <app-button variant="outlined" severity="contrast" (clicked)="toggleFilterPanel()" icon="pi pi-filter"
                    [disabled]="!projectActive" />
            </div>
        </div>
    </div>


    <ng-container *ngIf="!isLoading && documents.length === 0; else dataBlock">
        <div class="flex flex-col items-center justify-center h-full">
            <!-- <i [innerHTML]="PROJECT_DASHBOARD_SVG.EMPTY_STATE_DOCUMENTS | sanitizeHtml" alt="No Documents" class="text-lg w-1/2 h-1/2"> </i> -->

            <ng-container *ngIf="hasActiveFilters else noFiltersState">
                <span class="text-lg font-semibold">{{"no documents found" | textCase}}</span>
                <span class="text-sm text-gray-500">
                    {{'No documents match your current filter criteria.' | textCase}}
                </span>
            </ng-container>

            <ng-template #noFiltersState>
                <i [innerHTML]="PROJECT_DASHBOARD_SVG.EMPTY_STATE_DOCUMENTS | sanitizeHtml" alt="No Documents"> </i>
            </ng-template>
        </div>
    </ng-container>
    <ng-template #dataBlock>
        <app-grid-list-view [items]="documents" [viewMode]="viewMode" [gridItemTemplate]="gridItemTemplate"
            [actionBarTemplate]="actionBarTemplate" [(selectedItems)]="selectedDocuments" [dataKey]="'_id'"
            [scrollable]="true" [rows]="rows" [rowsPerPageOptions]="[5, 10, 20, 50]"
            [selectionChangeCallback]="onSelectionChange.bind(this)" [useDataTable]="viewMode === 'list'"
            [tableColumns]="currentTableColumns" [tableConfig]="currentTableConfig" [customTemplates]="templatesMap"
            [maxHeight]="'calc(100vh - 20rem)'" [totalRecords]="totalRecords" [first]="first" [showPaginator]="true"
            (pageChange)="onPageChange($event)" [parentClass]="'flex-1 flex flex-col min-h-0 h-full'" [gridCols]="1"
            [gridColsSm]="1" [gridColsMd]="2" [gridColsLg]="2" [gridColsXl]="4" [gridCols2xl]="4"
            [itemsLoading]="isLoading">
        </app-grid-list-view>

        <!-- Grid Item Template -->
        <ng-template #gridItemTemplate let-document>

            <app-document-card [document]="document" [currentUser]="currentUser"
                [contractMenuItems]="getMenuItems(document)" (documentClick)="openDocument($event)" [permissions]="{
                    canEdit: canEditDocuments(), 
                    canComment: permissions.canComment, 
                    canView: permissions.canView, 
                    canDelete: canEditDocuments(), 
                    canDownload: true,
                    }" (menuClick)="handleMenuClickEvent($event)" (popoverToggle)="handlePopoverToggle($event)">
            </app-document-card>
        </ng-template>

        <!-- Action Bar Template -->
        <ng-template #actionBarTemplate>
            @if(selectedDocuments && showActionBar) {
            <div class="action-bar">
                <div class="action-bar-content">
                    <p class="text-sm font-medium">
                        {{ getSelectedDocumentsCountText() }}
                    </p>
                    <div class="action-bar-divider"></div>
                    @if(selectedDocuments.length === 1){
                    @if(selectedDocuments[0].isPinned){
                    <app-button variant="outlined" severity="contrast" label="{{'Unpin' | textCase}}"
                        (clicked)="unpinDocuments()" [enableThrottle]="true" *ngIf="canEditDocuments()" />

                    }
                    @else{
                    <app-button variant="outlined" severity="contrast" icon="pi pi-thumbtack"
                        label="{{'Pin' | textCase}}" (clicked)="pinDocuments()" [enableThrottle]="true"
                        *ngIf="canEditDocuments() && !selectedDocuments[0].isPinned" />

                    }
                    <app-button variant="outlined" label="{{'Due Date' | textCase}}" severity="contrast"
                        icon="pi pi-calendar" (clicked)="openDueDateDialog()" *ngIf="canDeleteInActionbar()" />

                    }
                    <app-button variant="outlined" label="{{'Download' | textCase}}" severity="contrast"
                        icon="pi pi-download" (clicked)="downloadSelectedDocs()" [enableThrottle]="true"
                        [loading]="downloadLoading" [disabled]="downloadLoading" />

                    <app-button variant="outlined" label="{{'Add to workspace knowledge'}}" severity="contrast"
                        [icon]="SVGS.KNOWLEDGE_BASE_ICON" [iconSource]="'svg'" [iconPosition]="'left'"
                        (clicked)="openAddToWorkspaceKnowledgeDialog()" [enableThrottle]="true" />

                    <app-button variant="outlined" label="{{'Add to project knowledge'}}" severity="contrast"
                        [icon]="SVGS.OPEN_BOOK_CHECK" [iconSource]="'svg'" [iconPosition]="'left'"
                        (clicked)="openAddToProjectKnowledgeDialog()" [enableThrottle]="true" />

                    <div class="action-bar-divider" *ngIf="canDeleteInActionbar()"></div>
                    <app-button variant="outlined" label="{{'Delete'}}" severity="danger" icon="pi pi-trash"
                        class="text-red-500" (clicked)="deleteSelectedDocs()" *ngIf="canDeleteInActionbar()" />

                </div>
            </div>
            }
        </ng-template>

    </ng-template>
</div>

@if(createVisible){
<app-dialog [visible]="createVisible" (closed)="createVisible = false; onCreateDocumentHide()" title="Create a document"
    [fullscreenOnMobile]="true" class="max-w-[60vw]">
    <ng-template #bodyTemplate>
        <div class="mb-4">
            <p-tabs [value]="selectedTabIndex().toString()" (valueChange)="handleTabChange($event)"
                class="custom-tabview w-full">
                <p-tablist>
                    @for(tab of createDocumentDialogTabs();let i = $index; track tab.id) {
                    <p-tab [value]="i.toString()" [disabled]="tab.disabled" [pTooltip]="tab.tooltip || ''"
                        [tooltipPosition]="'top'" [showDelay]="300" class="flex items-center !gap-2">
                        <div class="flex items-center gap-2">
                            <span class="font-sans text-sm whitespace-nowrap"
                                [ngClass]="{'text-blue-700': selectedTabIndex() === i}">{{
                                tab.label
                                }}</span>
                        </div>
                    </p-tab>
                    }
                </p-tablist>
            </p-tabs>
        </div>
        @if(docTypeLoading){
        <p-skeleton width="100%" height="100%" />
        }
        @else{
        @if(selectedTabIndex() === 0){
        <div class="h-[70vh] overflow-y-auto">
            <div class="text-sm my-2 mb-4 font-semibold">Select document type</div>
            <div class="flex flex-row items-center justify-between gap-3 w-full mb-3">
                <span class="p-input-icon-left w-[40%]">
                    <app-search-bar placeholder="Search with name" [(ngModel)]="docTypeSearch"
                        (searchChange)="onDocTypeFilter()" width="100%"></app-search-bar>
                </span>
                <app-button label="New document type" variant="outlined" severity="contrast" icon="pi pi-plus"
                    (clicked)="navigateToAddDocType()" />
            </div>
            <div
                class="grid md:grid-cols-2 grid-cols-1 gap-2 auto-rows-min flex-1 min-h-0 overflow-y-auto content-start">
                @for (docType of filteredDocTypes; track docType._id) {
                <div appThrottleClick
                    class="flex flex-col gap-2 border p-4 justify-between rounded-base items-center cursor-pointer doc-type-item self-start"
                    (throttledClick)="selectDocType(docType)">
                    <div class="flex flex-row gap-2 w-full overflow-hidden">
                        <div class="overflow-hidden">
                            <span class="flex items-center font-semibold text-md">
                                {{docType?.name }}
                                @if(docType.containsForm){
                                <p-chip label="Contains Form"
                                    class="mx-2 bg-arena-orange !px-2 !py-1 rounded-base text-xs"></p-chip>
                                }
                            </span>
                            <span class="block text-sm text-gray-500 truncate max-w-full"
                                [pTooltip]="docType.description">{{docType.description}}
                            </span>
                        </div>
                    </div>
                    <div class="flex flex-row gap-2 w-full justify-between">
                        <div class="flex gap-1">
                            <span class="flex items-center text-sm text-gray-500 doc-type-description"
                                *ngIf="docType.createdAt">Created on</span>
                            <span class="flex items-center text-sm font-semibold " *ngIf="docType.createdAt">
                                {{ (docType.createdAt) | dateFormatter: 'Do MMM, YYYY' }}
                            </span>
                        </div>
                        <i class="pi pi-chevron-right my-auto"></i>
                    </div>
                </div>
                }
            </div>
        </div>
        }@else {
        <div class="text-sm my-2 font-semibold">Select document type <span class="text-red-500">*</span></div>
        <div class="flex flex-col gap-3">
            <div class="flex flex-col gap-2">
                <div class="flex flex-row items-center gap-3 w-full">
                    <app-select [(value)]="selectedDocTypeId" [options]="uploadDocumentTypeOptions"
                        [config]="docTypeSelectConfig" (onChange)="handleDocTypeChange($event)" class="w-full" />
                    <app-button label="New document type" variant="outlined" severity="contrast" icon="pi pi-plus"
                        (clicked)="navigateToAddDocType()" />
                </div>
            </div>
            <div class="w-[100%] overflow-y-auto max-h-[80%]">
                <app-file-upload-with-actions class="w-full" [multiple]="true" [fileTypes]="allowedFileTypes"
                    [maxFileSize]="50 * 1000 * 1000" [uploadedFiles]="uploadedFiles" [hideActionButtons]="true"
                    (filesChanged)="uploadedFiles = $event">
                </app-file-upload-with-actions>
            </div>
        </div>
        }
        }
    </ng-template>
    @if(selectedTabIndex() === 1){
    <ng-template #footerTemplate>
        <div class="flex justify-end items-end gap-2">
            <app-button label="Cancel" variant="ghost" severity="contrast" (clicked)="closeCreateDocumentDialog()" />
            <app-button label="Upload" variant="filled" severity="primary" [loading]="loadingState()"
                [disabled]="uploadedFiles.length === 0 || selectedDocTypeId === null" (clicked)="uploadFiles()"
                [enableThrottle]="true" />
        </div>
    </ng-template>
    }
</app-dialog>
}

@if(filterPanelVisible) {
<p-drawer [(visible)]="filterPanelVisible" position="right" class="w-[22rem]">
    <ng-template pTemplate="headless">
        <div class="flex flex-col h-full">
            <div class="flex items-center justify-between border-b p-4">
                <h2 class="text-lg font-semibold">{{'Filter' | textCase}}</h2>
                <i class="pi pi-times icon-sm" (click)="toggleFilterPanel(true)"></i>
            </div>
            <div class="flex-1 overflow-y-auto space-y-5 text-sm text-gray-800 p-4">
                <div>
                    <label class="block font-medium mb-1">{{'Document Name' | textCase}}</label>
                    <input pInputText [(ngModel)]="filterSearchValue" class="w-full p-2 border rounded-base"
                        placeholder="Enter Document Name" [style]="{ outline: 'none' }" />
                </div>
                <div>
                    <label class="block font-medium mb-1">{{'Document Type' | textCase}}</label>
                    <app-select [(value)]="filters.documentType" [options]="documentTypeOptions"
                        [config]="documentTypeConfig">
                    </app-select>
                </div>
                <div>
                    <label class="block font-medium mb-1">{{'Shared with' | textCase}}</label>
                    <app-multi-select [(value)]="filters.assignees" [options]="assigneeOptions" optionLabel="label"
                        optionValue="value" [config]="{placeholder: 'Select Assignee', filter: true,
                        searchPlaceholder: 'Search People', panelStyleClass: 'max-h-48 overflow-y-auto',
                        styleClass: 'w-full border border-gray-300 rounded-base'}">
                    </app-multi-select>
                </div>
                <div>
                    <label class="block font-medium mb-1">{{'Due Date' | textCase}}</label>
                    <app-datepicker [(value)]="filters.filterDueDateRange" [config]="{
                            selectionMode: 'range',
                            showIcon: true,
                            showClearButton: true,
                            dateFormat: 'dd M yy',
                            placeholder: 'Select Due Date',
                            appendTo: 'body',
                            
                        }" class="w-full" />
                </div>
                <div>
                    <label class="block font-medium mb-1">{{'Date Created' | textCase}}</label>
                    <app-datepicker [(value)]="filters.filterCreatedDateRange" [config]="{
                            selectionMode: 'range',
                            showIcon: true,
                            showClearButton: true,
                            dateFormat: 'dd M yy',
                            placeholder: 'Select Created Date',
                            appendTo: 'body',
                        }" class="w-full" />
                </div>
                <div>
                    <label class="block font-medium mb-1">{{'Date Updated' | textCase}}</label>
                    <app-datepicker [(value)]="filters.filterUpdatedDateRange" [config]="{
                            selectionMode: 'range',
                            showIcon: true,
                            showClearButton: true,
                            dateFormat: 'dd M yy',
                            placeholder: 'Select Updated Date',
                            appendTo: 'body',
                            inputStyleClass: 'w-full p-2 bg-white border-none outline-none text-gray-700'
                        }" class="w-full" />
                </div>
            </div>
            <div class="flex justify-between items-center px-6 py-4 border-t">
                <app-button label="{{'Clear all and apply' | textCase}}" variant="outlined" severity="contrast"
                    (clicked)="clearAllFilters()" />
                <app-button label="{{'Apply Filter' | textCase}}" variant="filled" severity="primary"
                    (clicked)="applyFilters()" />
            </div>
        </div>
    </ng-template>
</p-drawer>
}

<app-create-form [docType]="docCreationByDocumentType.doc" [project]="projectId" [projectDueDate]="projectDueDate"
    [visible]="docCreationByDocumentType.visible"
    (visibleChange)="docCreationByDocumentType.visible = $event"></app-create-form>


<!-- Data Table Templates -->
<!-- Document Name Template -->
<ng-template #documentNameTemplateRef let-document="$implicit">
    <div class="text-sm text-gray-600 -mx-2 px-2 py-1 rounded flex transition-all" [ngClass]="{
            'cursor-pointer hover:bg-gray-50': projectActive,
            'cursor-not-allowed': !projectActive
        }" (click)="projectActive ? openDocument(document._id, $event) : null">
        <div class="flex items-center justify-center">
            <span [ngClass]="{
            'hover:text-arena-orange transition-colors': projectActive,
                'text-gray-400': !projectActive
        }" class="text-sm" [pTooltip]="document.name" tooltipPosition="bottom"
                [showDelay]="300">{{document.name}}</span>
            @if(document.dueDateExceeding) {
            <i [innerHTML]="SVG.DUE_DATE_EXCEEDING | sanitizeHtml" alt="Due Date Exceeding" tooltipPosition="bottom"
                [pTooltip]="'Overdue (' + (document.dueDate | date:'MMM d') + ')'" class="ml-2"></i>
            }
        </div>
    </div>
</ng-template>

<!-- Assignees Template -->
<ng-template #assigneesTemplateRef let-document="$implicit">
    <div class="truncate text-sm text-gray-600 flex items-center gap-2 justify-center">
        <app-avatar-stack [users]="document.assignees" [visibleAvatars]="2" size="xs">
        </app-avatar-stack>
    </div>
</ng-template>

<!-- Date Updated Template -->
<ng-template #dateUpdatedTemplateRef let-document="$implicit">
    <div class="truncate text-sm text-gray-600" [pTooltip]="(document.updatedAt | dateFormatter: 'Do MMMM, YYYY') ?? ''"
        tooltipPosition="bottom" [showDelay]="300">
        {{document.updatedAt | dateFormatter: 'Do MMMM, YYYY'}}
    </div>
</ng-template>

@if(deleteConfirmationVisible){
<app-delete-confirmation [(visible)]="deleteConfirmationVisible"
    [headerText]="'Delete Document' + (selectedDocuments.length > 1 ? 's' : '') | textCase"
    [bodyText]="'Are you sure you want to permanently delete ' + (selectedDocuments.length === 1 ? 'this document' : selectedDocuments.length + ' documents') | textCase"
    [confirmButtonText]="'Delete' | textCase" [requireConfirmation]="true" [loading]="deleteConfirmationLoading"
    (onConfirm)="handleDeleteConfirm()" (onCancel)="handleDeleteCancel()">
</app-delete-confirmation>
}

<!-- Status Template -->
<ng-template #statusTemplateRef let-document="$implicit">
    <div class="flex gap-2 items-center">
        @if(document.documentStatus) {
        <div class="rounded-base px-2 py-1 flex items-center justify-center truncate max-w-[6.25rem] theme-text-border"
            [pTooltip]="getStatus(document)" tooltipPosition="bottom" [showDelay]="300">
            <span class="theme-text text-xs font-medium">{{getStatus(document)}}</span>
        </div>
        }
    </div>
</ng-template>

<!-- Document Type Template -->
<ng-template #documentTypeTemplateRef let-document="$implicit">
    <div class="text-sm text-gray-700 truncate max-w-[10rem]" [pTooltip]="document.linkedDocType?.name || 'No type'"
        tooltipPosition="bottom" [showDelay]="300">
        {{ document.linkedDocType?.name || ('No type' | titlecase) }}
    </div>
</ng-template>

<!-- Due Date Template -->
<ng-template #dueDateTemplateRef let-document="$implicit">
    <div class="text-sm"
        [ngClass]="{'text-danger font-semibold': document.dueDateExceeding, 'font-light': !document.dueDateExceeding}"
        [pTooltip]="(document.dueDate | date: 'dd MMM yyyy') ?? 'No due date'" tooltipPosition="bottom"
        [showDelay]="300">
        {{document.dueDate | date: 'dd MMM yyyy' }}
    </div>
</ng-template>

<!-- Upcoming Milestone Template -->
<ng-template #upcomingMilestoneTemplateRef let-document="$implicit">
    <div class="truncate text-sm text-gray-600">
        @if(document.upcomingMilestone && document.upcomingMilestone.length > 0){
        <div class="flex items-center gap-2 text-xs text-gray-600">
            <i class="pi pi-flag text-arena-orange-500"></i>
            <span class="truncate max-w-[10rem]" [pTooltip]="document.upcomingMilestone[0].name"
                tooltipPosition="bottom" [showDelay]="300">{{
                document.upcomingMilestone[0].name }}</span>
            <span class="text-gray-400">•</span>
            <span class="rounded-base bg-arena-orange-100 text-arena-orange py-1 px-2 w-fit whitespace-nowrap">
                {{ document.upcomingMilestone[0].date | date: 'MMM d' }}
            </span>
        </div>
        }@else {
        <div class="text-sm text-gray-400 italic flex items-center gap-2">
            <i class="pi pi-flag"></i>
            <span>{{'No upcoming milestones'}}</span>
        </div>
        }
    </div>
</ng-template>

<!-- Actions Template -->
<ng-template #actionsTemplateRef let-document="$implicit">
    <div class="flex items-center justify-center" (click)="$event.stopPropagation()">
        <app-popover #menu width="12rem">
            <ng-template #trigger>
                <i class="pi pi-ellipsis-v cursor-pointer icon-sm"></i>
            </ng-template>
            <ng-template #body>
                <div class="flex flex-col text-sm">
                    @if(document.isPinned){
                    <div (click)="unpinDocuments(document); menu.hide()"
                        class="flex items-center gap-2 px-4 py-2 hover:bg-gray-50 cursor-pointer transition-colors">
                        <i [innerHTML]="SVG.UNPIN | sanitizeHtml" class="text-sm"></i>
                        <span>Unpin</span>
                    </div>
                    }
                    @else{
                    <div (click)="pinDocuments(document); menu.hide()"
                        class="flex items-center gap-2 px-4 py-2 hover:bg-gray-50 cursor-pointer transition-colors">
                        <i [innerHTML]="SVG.PIN | sanitizeHtml" class="text-sm"></i>
                        <span>Pin</span>
                    </div>
                    }
                    @if(canEditDocument(document)){
                    <div (click)="openDueDateDialog(document); menu.hide()"
                        class="flex items-center gap-2 px-4 py-2 hover:bg-gray-50 cursor-pointer transition-colors">
                        <i class="pi pi-calendar text-sm"></i>
                        <span>Due Date</span>
                    </div>
                    }
                    <div (click)="selectedDocuments = [document]; downloadSelectedDocs(); menu.hide()"
                        class="flex items-center gap-2 px-4 py-2 hover:bg-gray-50 cursor-pointer transition-colors">
                        <i class="pi pi-download text-sm"></i>
                        <span>Download</span>
                    </div>
                    <div (click)="selectedDocuments = [document]; openAddToWorkspaceKnowledgeDialog(); menu.hide()"
                        class="flex items-center gap-2 px-4 py-2 hover:bg-gray-50 cursor-pointer transition-colors">
                        <i [innerHTML]="SVGS.KNOWLEDGE_BASE_ICON | sanitizeHtml" class="text-sm"></i>
                        <span>Add to workspace knowledge</span>
                    </div>
                    <div (click)="selectedDocuments = [document]; openAddToProjectKnowledgeDialog(); menu.hide()"
                        class="flex items-center gap-2 px-4 py-2 hover:bg-gray-50 cursor-pointer transition-colors">
                        <i [innerHTML]="SVGS.OPEN_BOOK_CHECK | sanitizeHtml" class="text-sm"></i>
                        <span>Add to project knowledge</span>
                    </div>
                    @if(canDeleteDocument(document)){
                    <div (click)="selectedDocuments = [document]; deleteSelectedDocs(); menu.hide()"
                        class="flex items-center gap-2 px-4 py-2 hover:bg-gray-50 cursor-pointer transition-colors text-danger">
                        <i class="pi pi-trash text-sm text-red-500"></i>
                        <span class="text-red-500">Delete</span>
                    </div>
                    }
                </div>
            </ng-template>
        </app-popover>
    </div>
</ng-template>


<!-- Rename Document Dialog -->
@if(rename.open) {
<app-dialog [visible]="rename.open" title="Rename Document" [fullscreenOnMobile]="true" class="max-w-[30rem]"
    [style]="{ width: '30rem' }" (onHide)="resetRename()" (clickOutside)="resetRename()">
    <ng-template #bodyTemplate>
        <div class="flex flex-col align-items-center py-4 px-6 surface-overlay border-round">
            <span class="font-bold text-xl block mb-2 mt-4">{{'Rename Document' | textCase}}</span>
            <p class="mb-0">{{'Enter the new name for the Document:' | textCase}}</p>
            <div class="flex align-items-center gap-3 my-3 w-full">
                <input class="rename-input w-full" pInputText id="newDocumentName" (click)="$event.stopPropagation()"
                    [(ngModel)]="rename.newName" autocomplete="off" />
            </div>
            <div class="flex justify-end items-end gap-2 mt-4">
                <app-button label="{{'Cancel' | textCase}}" variant="outlined" severity="contrast"
                    (clicked)="rename.open = false" />
                <app-button label="{{'Save' | textCase}}" icon="pi pi-save" (clicked)="renameDocument($event)"
                    [enableThrottle]="true" variant="filled" severity="primary" />
            </div>
        </div>
    </ng-template>
</app-dialog>
}

<!-- Due Date Dialog -->
@if(dueDate.open) {
<app-dialog [visible]="dueDate.open" (closed)="resetDueDate()" title="Due Date" [fullscreenOnMobile]="true"
    class="max-w-[30rem]">
    <ng-template #bodyTemplate>
        <p class="mb-0 text-sm text-gray-600">{{'Select the Due Date for this document:' | textCase}}</p>
        <div class="flex items-center gap-3 my-3">
            <app-datepicker [(value)]="dueDate.selectedDate" [config]="{
                    showIcon: true,
                    placeholder: 'Select Due Date',
                    dateFormat: 'dd MM yy',
                    minDate: currentDate,
                    appendTo: 'body'
                }" />
        </div>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex justify-end items-end gap-2">
            <app-button label="{{'Cancel' | textCase}}" variant="outlined" severity="contrast"
                (clicked)="resetDueDate()" />
            <app-button label="{{'Save' | textCase}}" variant="filled" severity="primary" icon="pi pi-save"
                (clicked)="saveDueDate($event)" [enableThrottle]="true" />
        </div>
    </ng-template>
</app-dialog>
}


<!-- Add to Workspace Knowledge Dialog -->
<app-knowledge-base-dialog [(visible)]="addToWorkspaceKnowledgeDialog.visible" [scope]="'workspace'"
    [workspace]="getWorkspaceId()" [documentCount]="selectedDocuments.length"
    [uploading]="addToWorkspaceKnowledgeDialog.uploading" (upload)="uploadToWorkspaceKnowledge($event)">
</app-knowledge-base-dialog>

<!-- Add to Project Knowledge Dialog -->
<app-knowledge-base-dialog [(visible)]="addToProjectKnowledgeDialog.visible" [scope]="'project'" [project]="projectId"
    [documentCount]="selectedDocuments.length" [uploading]="addToProjectKnowledgeDialog.uploading"
    (upload)="uploadToProjectKnowledge($event)">
</app-knowledge-base-dialog>